import React from 'react';

function CheckWhiteIcon() {
    return (
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="22" height="22" rx="4" fill="white"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M16.0246 7.29512C16.2695 7.50945 16.2917 7.88283 16.0738 8.12464L9.94074 14.932C9.72173 15.1751 9.3457 15.1905 9.10749 14.9663L5.55847 11.6252C5.33714 11.4169 5.31595 11.0697 5.50585 10.8323C5.71538 10.5704 6.10558 10.5343 6.35495 10.7586L9.10851 13.2354C9.3478 13.4506 9.71622 13.4314 9.93181 13.1924L15.2072 7.34337C15.4206 7.10668 15.7847 7.08522 16.0246 7.29512V7.29512Z" fill="#37C26F"/>
        </svg>


    );
}

export default CheckWhiteIcon;
